import { makeStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/CloseRounded';

const useStyles = makeStyles(() => ({
	container: {
		'&:hover': {
			backgroundColor: '#f2f2f2',
		},
		alignItems: 'center',
		border: '1px solid #CFD8E3',
		borderRadius: 4,
		cursor: 'pointer',
		display: 'flex',
		height: 26,
		justifyContent: 'center',
		width: 26,
	},
	// NOTE:
	// ./src/modules/Private/Courses/Course.tsx[22:8]
	icon: (props: any) => ({
		fill: props.iconColor,
		height: 16,
		width: 16,
	}),
}));

// NOTE:
// ./src/modules/Private/Courses/Course.tsx[22:8]
export function CloseButton(props: any) {
	const iconColor = props.iconColor ? props.iconColor : 'black';
	const classes = useStyles({ iconColor });

	return (
		<div className={classes.container} {...props}>
			<CloseIcon className={classes.icon} />
		</div>
	);
}
